import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard {
  constructor(private authService: AuthService) {}

  canAccess(): Observable<boolean> {
    return this.authService.isAuthenticated$.pipe(
      map((authenticated) => !this.authService.preventNavigation && authenticated),
      first(),
    );
  }

  canActivate(route?: ActivatedRouteSnapshot): Observable<boolean> {
    return this.canAccess();
  }

  canActivateChild(route?: ActivatedRouteSnapshot): Observable<boolean> {
    return this.canAccess();
  }

  canLoad(route?: Route): Observable<boolean> {
    return this.canAccess();
  }
}
